// extracted by mini-css-extract-plugin
export default {"header":"Organogram_header__Foj6g","img_wrapper":"Organogram_img_wrapper__c7LwJ","img":"Organogram_img__pRiEy","h2":"Organogram_h2__2r9d1"};